export default function validate(mail) {
    let errors = {};

    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (!mail.firstName) {
        errors.firstName = 'The required field is missing.'
    };

    if (!mail.lastName) {
        errors.lastName = 'The required field is missing.'
    };

    if (!mail.email) {
        errors.email = 'The required field is missing.'
    } else if (!emailPattern.test(mail.email)) {
        errors.email = 'Please, insert a valid email.'
    }

    if (!mail.message) {
        errors.message = 'The required field is missing.'
    };

    return errors;
}